import React from "react";
import { IconProps } from "types/icon";

const Mission: React.FC<IconProps> = ({
  size = "16",
  color = "currentColor",
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      color={color}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
      viewBox="0 0 62 62"
    >
      <circle
        cx="30.9378"
        cy="30.9378"
        r="30.1878"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.9155 27.6939L43.2478 37.8537C43.3671 38.019 43.249 38.25 43.0451 38.25H18V39.75H43.0451C44.4724 39.75 45.2994 38.1333 44.4641 36.9759L37.6254 27.5L44.4641 18.0241C45.2994 16.8667 44.4724 15.25 43.0451 15.25H18V16.75H43.0451C43.249 16.75 43.3671 16.981 43.2478 17.1463L35.9155 27.3061L35.7315 27.4389L35.7756 27.5L35.7315 27.5611L35.9155 27.6939Z"
        fill="currentColor"
      />
      <path d="M18 59V15" stroke="currentColor" stroke-width="1.5" />
    </svg>
  );
};

export default Mission;
